import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import _ from 'lodash';
import * as clientCodeAction from '../redux/actions/clientCodeAction';
import './ClientCode.less';

class ClientCode extends Component {

  searchDebounce = _.debounce((search_string) => {
    this.getClientCodes(search_string);
    this.setState({ searchedStr: search_string });
  }, 700);

  constructor(props) {
    super(props);
    this.state = {
      searchedStr: '',
      showClientCodeMsg: false, // show-hide the msg div
    };
  }

  componentDidMount() {
    const { initialClientCode, dispatch } = this.props;

    if (initialClientCode) {
      dispatch(clientCodeAction.savedCodes({}, initialClientCode.value));
    }

    const { clientCodeChanged, searchedClientCode } = this.getUsedCodeForCase();
    if (clientCodeChanged && searchedClientCode) {
      document.addEventListener('mousedown', this.hideClientCodeMsg);
      if (!this.props.ignoreClientCodeAutosetMsg) {
        this.setState({ showClientCodeMsg: true });
      }
    }
  }

  componentWillUnmount() {
    const { clientCodeChanged } = this.getUsedCodeForCase();
    if (clientCodeChanged) document.removeEventListener('mousedown', this.hideClientCodeMsg);
  }

  getUsedCodeForCase = () => {
    const clientCodeChanged = _.get(window, 'Drupal.settings.clientCodeChanged', false);
    const searchedClientCode = _.get(window, 'Drupal.settings.clientCode', '');
    return { clientCodeChanged, searchedClientCode };
  }

  getClientCodes = (value) => {
    const { hasMadeRequest, dispatch } = this.props;
    if (!hasMadeRequest) {
      dispatch(clientCodeAction.getClientCodes(value));
    }
  }

  setClientCode = (code) => {
    const { value } = code;
    const { dispatch } = this.props;
    dispatch(clientCodeAction.setClientCode(value));
    this.setState({ searchedStr: value }, () => {
      this.refs.clientCodeSelectRef.select.closeMenu();
    });
  }

  onClientCodeSelected = (client_code_string) => {
    // when selected is removed from dropdown
    if (typeof client_code_string === 'function') {
      // call valReset case where user saves some value
      client_code_string();
    }
    let val = '';
    if (client_code_string) {
      const { value } = client_code_string;
      val = value;
    }
    this.setClientCode({ value: val });
  }

  loadPreviousClientCode = () => {
    const { loadedPrevClientCodeList } = this.props;
    if (!loadedPrevClientCodeList) {
      this.getClientCodes();
    }
  }

  resetValue = () => {
    const value = '';
    this.setClientCode({ value });
    this.props.dispatch(clientCodeAction.getClientCodes(value));
  }

  promptTextCreator = (search_string) => {
    const displayVal = `New code: ${search_string} `;
    const { hasMadeRequest } = this.props;
    const { searchedStr } = this.state;
    if (hasMadeRequest || searchedStr === search_string) {
      return displayVal;
    }
    this.searchDebounce(search_string);
    return displayVal;
  }

  hideClientCodeMsg = () => {
    this.setState({ showClientCodeMsg: false });
  }

  render() {
    const {
      clientCodeList,
      sessionClientCode,
      hasMadeRequest,
      placeholder,
      autoFocus,
      ignoreClientCodeAutosetMsg,
      openOnFocus,
    } = this.props;

    let clientCodeMsg = (<div />);
    const { showClientCodeMsg, searchedStr } = this.state;

    if (showClientCodeMsg) {
      clientCodeMsg = (
        <div id="clientMsg" className="highlight" onClick={this.hideClientCodeMsg}>
          <div id="clientMsgCloseBtn">X</div>
          <div id="clientCodeMsg">
            Code Client was automatically set to the last one used on this case
          </div>
        </div>
      );
    }

    const { clientCodeChanged, searchedClientCode } = this.getUsedCodeForCase();
    const displayCode = sessionClientCode ? sessionClientCode : searchedClientCode;

    let options = [];
    if (clientCodeList) {
      options = clientCodeList.reduce((accum, next) => {
        const { id, text, children } = next;
        if (children) {
          accum.push({ value: id, label: text , className: 'client-code-option-parent' });
          const codes = children.map(p => ({ value: p.id, label: p.text, className: 'client-code-option-child' }));
          accum = accum.concat(codes);
        } else {
          accum.push({ value: id, label: text });
        }
        return accum;
      }, []);
    }

    if (displayCode) {
      const v = _.get(displayCode, 'value', displayCode);
      options.push({ value: v, label: v, className: 'hello' });
      options = _.uniqBy(options, 'label');
    }
    const value = searchedStr || displayCode;

    const lockedClientCode = this.props.initialClientCode || displayCode;

    return (
      <div className={`${this.props.className} selector-container`}>
        <div className="select-wrapper">
          <label htmlFor="client_code_select"
                 title="Search for code you used previously or enter a new one.
             Only codes that you make a purchase with will be remembered">
            Client Code
          </label>
          <div className="select-box-container"
               onClick={this.props.isClientCodeLocked ? () => false : this.loadPreviousClientCode}
               title={this.props.isClientCodeLocked ? 'Locked via "Department Code" in your account settings': '' }
          >
            {this.props.isClientCodeLocked
              ?
              <Select.Creatable
                disabled={ true }
                name="client-code"
                value={ lockedClientCode }
                options={ [ { value: lockedClientCode, label: lockedClientCode }] }
                className="react-select-container"
                ref="clientCodeSelectRef"
              />

              :
              <Select.Creatable
                placeholder={placeholder}
                name="client-code"
                options={options}
                promptTextCreator={this.promptTextCreator}
                value={value}
                onNewOptionClick={this.setClientCode}
                clearable
                onChange={this.onClientCodeSelected}
                isLoading={hasMadeRequest}
                onFocus={this.loadPreviousClientCode}
                searchable
                backspaceRemoves
                deleteRemoves
                resetValue={this.resetValue}
                className="react-select-container"
                autoFocus={autoFocus}
                ref="clientCodeSelectRef"
                // openOnFocus={openOnFocus}
              />
            }
          </div>
        </div>
        { clientCodeMsg }
      </div>
    );
  }
}

function mapStateToProps(state) {
  const clientCodeReducer = state.get('clientCodeReducer').toJS();
  const { clientCodeList, hasMadeRequest, loadedPrevClientCodeList, sessionClientCode } = clientCodeReducer;
  return {
    clientCodeList,
    hasMadeRequest,
    loadedPrevClientCodeList,
    sessionClientCode,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

ClientCode.defaultProps = {
  // these are only being used for the storybook.
  // set both to true to display the dropdown
  sessionClientCode: null,
  placeholder: 'Enter one or select...',
  autoFocus: false,
  openOnFocus: false,
  ignoreClientCodeAutosetMsg: false,
  className: '',
};

ClientCode.propTypes = {
  initialClientCode: PropTypes.string.isRequired,
  isClientCodeLocked: PropTypes.bool,
  sessionClientCode: PropTypes.string,
  clientCodeList: PropTypes.array.isRequired,
  hasMadeRequest: PropTypes.bool.isRequired,
  loadedPrevClientCodeList: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  openOnFocus: PropTypes.bool,
  ignoreClientCodeAutosetMsg: PropTypes.bool,
  className: PropTypes.string,
};
// for storybook without redux wiring
export { ClientCode as PureClientCode };

export default connect(mapStateToProps, mapDispatchToProps)(ClientCode);



// WEBPACK FOOTER //
// ./src/clientCode/ClientCode.jsx